var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReopenJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8397 35.7183C29.5385 44.8992 28.011 54.805 28.011 54.805L28.8024 78.0508L28.9574 94.5297C28.9574 94.5297 30.5266 120.962 30.5538 123.852L30.8926 147.466C31.039 156.832 35.5866 164.229 41.07 163.952L127.288 161.174C132.753 161.031 137.139 153.38 137.109 144.011L136.056 32.2294C135.89 22.831 131.343 15.4678 125.879 15.7767L39.6419 18.5554C34.1764 18.6617 29.7902 26.346 29.8397 35.7183Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0783 61.9643C28.0777 61.8986 28.0771 61.8331 28.0764 61.7675C28.1354 55.0393 28.3776 48.3051 28.9259 41.594C29.3655 36.33 30.0277 30.8948 31.964 26.567C34.2005 21.6389 37.4076 19.5176 41.561 17.5628C45.8093 15.5633 49.0942 16.6638 52.8676 16.936C69.7768 18.1957 86.7203 18.7654 103.647 17.4981C110.816 16.9718 118.003 16.084 125.199 16.2131C130.928 16.291 140.026 14.8823 142.49 25.5321C143.341 29.3108 143.319 33.4457 143.276 37.4829C142.814 75.0338 142.373 112.617 141.932 150.167C141.901 153.351 141.77 156.8 140.447 159.14C139.023 161.581 134.645 162.083 134.645 162.083C134.645 162.083 70.651 167.229 38.6338 169.836C37.6356 169.901 36.5967 169.967 35.6931 169.241C34.1108 167.881 33.6924 164.581 33.4614 161.701C32.3755 148.119 31.2895 134.538 30.407 120.917",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6061 85.5348L119.262 81.876",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8053 37.7038L115.204 35.4125",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1836 101.888L102.648 103.192",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5352 124.015L45.2313 124.804",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8828 146.146L44.5789 146.936",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.134 57.6378L44.5781 60.3379",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.483 132.651C120.937 129.691 124.591 136.516 125.361 140.299C123.643 143.191 111.884 153.325 109.93 153.338C107.976 153.351 109.278 144.93 112.483 132.651Z",
    fill: "#F4F4F5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2556 23.8884C33.3627 19.3856 38.8098 15.3731 44.5371 11.8948C46.0811 10.7457 47.8168 9.94668 49.6431 9.54445C51.7304 9.35819 53.8188 9.8817 55.6273 11.0445C55.6273 11.0445 55.7 11.0448 55.7205 11.1135C56.2074 11.3788 56.6838 11.6783 57.1601 11.9893C62.3376 15.444 66.8965 20.4994 68.8137 26.8498C69.1586 28.0166 69.418 29.2122 69.5891 30.425C70.0449 33.9298 69.8298 37.5017 68.9577 40.9103C67.7339 45.511 65.6371 49.7726 62.8062 53.4123C59.4936 58.0172 55.0251 61.4446 49.9586 63.2666C47.9801 63.9255 45.9272 64.2722 43.861 64.2964C37.6321 64.364 31.3403 61.8438 25.8198 58.5022C24.7517 57.8724 23.7148 57.1805 22.7134 56.4293C20.8738 55.1399 19.2621 53.4927 17.9565 51.5679C11.765 41.7547 21.7652 29.9545 28.2556 23.8884Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2496 22.0309C48.4397 21.1408 52.916 22.3658 56.2523 25.0131C57.6022 26.0836 58.7695 27.3891 59.6507 28.8713C61.6127 32.1699 62.2418 36.1694 61.7613 39.9766C61.2808 43.7838 59.7402 47.4077 57.651 50.6272C56.0505 53.0934 54.0899 55.3762 51.6282 56.9841C49.1664 58.592 46.1621 59.4836 43.2516 59.0629C40.7277 58.6985 38.4227 57.3841 36.4658 55.7496C32.1426 52.1382 29.2942 46.837 28.5683 41.2511C28.0035 36.9049 28.7745 32.2291 31.4884 28.7885C34.4891 24.9843 39.2921 23.2463 43.843 22.1241C43.9783 22.0908 44.1136 22.0597 44.2496 22.0309Z",
    fill: "#399D81"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6857 34C37.0644 34 37.3714 34.307 37.3714 34.6857V37.5198C38.8093 35.3965 42.241 32.5 45 32.5C50.5 33.3715 51.446 37.0539 51.9381 41.0009C51.985 41.3767 51.7183 41.7193 51.3425 41.7662C50.9667 41.813 50.6241 41.5464 50.5773 41.1706C50.1696 37.9015 49.5 34.3714 45 33.8714C42.5948 33.8714 39.4876 36.6526 38.3257 38.5714H41.2571C41.6359 38.5714 41.9429 38.8784 41.9429 39.2571C41.9429 39.6359 41.6359 39.9429 41.2571 39.9429H36.6857C36.307 39.9429 36 39.6359 36 39.2571V34.6857C36 34.307 36.307 34 36.6857 34ZM36.6575 42.2338C37.0333 42.187 37.3759 42.4536 37.4227 42.8294C37.8304 46.0985 39.6203 49.3143 43 49.3143C45.4052 49.3143 48.5124 47.3474 49.6743 45.4286H46.7429C46.3641 45.4286 46.0571 45.1216 46.0571 44.7429C46.0571 44.3642 46.3641 44.0571 46.7429 44.0571H51.3143C51.693 44.0571 52 44.3642 52 44.7429V49.3143C52 49.693 51.693 50 51.3143 50C50.9356 50 50.6286 49.693 50.6286 49.3143V46.4802C49.1907 48.6035 45.759 50.6857 43 50.6857C38.9199 50.6857 36.554 46.9462 36.0619 42.9991C36.015 42.6233 36.2817 42.2807 36.6575 42.2338Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5527 23.3936C33.4602 23.6309 25.471 32.0053 25.7083 42.0977C25.9374 51.8568 33.7944 59.7129 43.5534 59.9429C53.6466 59.9429 63.8389 49.7144 63.8389 39.6574C63.83 30.3833 54.621 23.3936 43.5527 23.3936Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReopenJob);
export default __webpack_public_path__ + "static/media/reopen-job.75ef61a3dc1df2c3afe2d01ccaa01fda.svg";
export { ForwardRef as ReactComponent };